import { IOS, UAParser, UAParserInstance } from 'ua-parser-js';

enum OS_TYPES {
  IOS = 'iOS',
}

export class DeviceService {
  private _UA: UAParserInstance;
  private _os: IOS;

  constructor() {
    this._UA = new UAParser();
    this._os = this._UA.getOS();
  }

  getNavigatorInstance(): Navigator {
    if (typeof window !== 'undefined') {
        return window.navigator || navigator;
    }
    return undefined;
  }

  isIOSType() {
    return this._os.name === OS_TYPES.IOS;
  }

  getIPad13() {
    return this.isIOS13Check('iPad');
  }

  isIOS13Check(type) {
    const nav = this.getNavigatorInstance();
    return nav?.platform && (nav.platform.indexOf(type) >= 0 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
  }

  isOS() {
    return this.isIOSType() || this.getIPad13();
  }
}
